export default __webpack_public_path__ + "static/media/wuhanlab.9c66c41d.9c66c41d.png";